import React from "react";

import Footer from "../components/Shared/Footer";

const Prediabetes = () => {
  return (
    <div>
      {/* Breadcrumb Section */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Pre-diabetes</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">
                      Reducarb Benefits
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section> 

      {/* Defining Prediabetes Section */}
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 mb-3">
              <div className="custom-image-container fresh-image ">
                <img
                  src="../assets/images/ReducarbPrediabites/Prediabites-three.jpg"
                  alt="Abdominal Obesity"
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">Defining Pre-diabetes</h1>
                    </div>
                    <div className="font-md">
                      <p className="justify_content">
                        Pre-diabetes means your blood glucose levels are higher
                        than normal but not high enough to be diagnosed as
                        diabetes. Pre-diabetes, in other words simply means being
                        on the edge of becoming a person with diabetes or a
                        stage before you may become a diabetic.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Understanding Prediabetes Section */}
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">
                        Understanding Pre-diabetes
                      </h1>
                    </div>
                    <div className="mb-2">
                      <div className="font-sm mb-1 fw-semibold">
                        India and Pre-diabetes: The Mounting Burden!
                      </div>
                      <p className="font-xsm">
                        We Indians are more prone to diabetes and hence, the
                        prevalence of diabetes and pre-diabetes incidence in India
                        is slightly higher than rest of the world.
                        <span className="color-blue-abdominal fw-semibold font-xsm mt-2">
                          India has 14 crores people with pre-diabetes i.e. 15.3%
                          Indians have pre-diabetes, which is MORE than number of
                          Diabetics in India.
                        </span>
                      </p>
                    </div>

                    <div>
                      <div className="font-sm fw-semibold mb-1">
                        Is Pre-diabetes Reversible?
                      </div>
                      <p className="font-xsm">
                        Yes, absolutely !!  One can reverse pre-diabetes by
                        making healthy dietary & lifestyle changes. Some people
                        may be prescribed medicines to address concomitant
                        conditions.
                      </p>
                    </div>

                    <div className="color-blue-abdominal fw-semibold font-xsm mt-2">
                      There are more pre-diabetics than diabetics in India.
                      Luckily, it can be reversed easily!!!
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5 ">
              <div className="custom-image-container fresh-image ">
                <img
                  src="../assets/images/ReducarbPrediabites/Prediabite-two.jpg"
                  alt="Abdominal Obesity"
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testing for Prediabetes Section */}
      <section className="fresh-vegetable-section client-section  section-lg-space">
        <div className="container-fluid-lg">
          <div className="review-title">
            <h1 className="font-lg mb-3">Testing for Pre-diabetes</h1>
          </div>
          <div>
            <div className="font-sm mb-1 fw-semibold">
              How to Know if You Are a Pre-diabetic?
            </div>
            <p className="font-xsm">
              A simple blood sugar test can help you find if you have
              pre-diabetes. Your doctor will ask to do the fasting plasma glucose
              (FPG) test or the HbA1C test to diagnose pre-diabetes. Less often,
              doctors use the oral glucose tolerance test (OGTT).
            </p>
          </div>
          <div>
            <div className="font-sm mb-3 fw-semibold">
              Results indicating pre-diabetes are:
            </div>
            <div className="row">
              <div className="col-xl-4 mb-2">
                <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue h-100  align-items-center  d-flex justify-content-center p-4">
                  <div>
                    <h3 className="font-md text-white mb-1 ">
                      HbA1C of 5.7–6.4%
                    </h3>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 mb-2">
                <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue h-100  align-items-center  d-flex justify-content-center p-4">
                  <div>
                    <h3 className="font-md text-white mb-1 ">
                      Fasting blood glucose of
                    </h3>
                    <h3 className="font-md text-white text-center">
                      100–125 mg/dL
                    </h3>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 mb-2">
                <div className="custom-image-container fresh-image-2 border_radius_col_six backcolo_blue d-flex  h-100  align-items-center  justify-content-center p-4">
                  <div>
                    <h3 className="font-md text-white mb-1 ">
                      An OGTT two-hour blood
                    </h3>
                    <h3 className="font-md text-white text-center">
                      glucose of 140–199 mg/dL
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="font-md mt-2">
              <div className=" custom-list-item-height-two mb-2 text-muted font-xsm">
                Generally, in pre-diabetes, there are no visible symptoms, however, you may have following complaints :
              </div>
              <div className="custom-list-effectonhealth mb-2 ps-3 text-muted ">
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  You're a lot thirstier than usual
                </div>
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  You pee a lot
                </div>
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  You’re a lot more tired than usual
                </div>
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  You have areas of darker skin in your armpit or on your neck
                </div>
              </div>

              <div className="font-xsm fw-semibold color-blue-abdominal">
                In simple terms, consult your Doctor and Dietician, if your
                HbA1C is between 5.7 to 6.4 and / or fasting sugar is between
                100-125 mg /dL.  Please check for Pre-diabetes risk calculator on
                our website.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-lg-space">
        <div className="container-fluid-lg">
          <div className="d-flex justify-content-center align-items-center">
            <div className="text-center">
              <h1 className="font-lg mb-3">Risks for Pre-diabetes</h1>
              <div className="text-center">
                <div className="font-sm mb-1 fw-semibold">
                  Are you at a risk of pre-diabetes?
                </div>
                <div className=" d-flex justify-content-center align-items-center mb-4">
                  <p className="">
                    If you are someone who has a genetic or lifestyle risk
                    factors, then you are more likely to develop insulin
                    resistance or pre-diabetes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div></div>

          <div className="row  mb-4">
            <div className="col-xl-6 mb-2 d-flex align-items-stretch">
              <div className="Efffect-grey-section">
                <div className="font-md mt-2">
                  <div className=" custom-list-item-height-two mb-2 text-muted fw-semibold font-xsm">
                    Some of the risk factors include, if you are:
                  </div>
                  <div className="custom-list-effectonhealth mb-2 ps-3 text-muted ">
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Overweight or obese
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Age 45 or older
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Parent, brother, or sister with diabetes
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Not physically active and/or you don't consume
                      healthy diet or enough fruit, veggies, nuts, whole grains,
                      or olive oil etc..
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Polycystic ovary syndrome, also called PCOS
                    </div>

                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      People who have metabolic syndrome—a combination of high
                      blood pressure, abnormal cholesterol levels, and large
                      waist size—are more likely to have pre-diabetes
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 mb-2 d-flex align-items-stretch">
              <div className="Efffect-grey-section">
                <div className="font-md mt-2">
                  <div className=" custom-list-item-height-two mb-2 text-muted fw-semibold font-xsm">
                    Along with these risk factors, other things that may
                    increase your risk are:
                  </div>
                  <div className="custom-list-effectonhealth mb-2 ps-3 text-muted ">
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Sleep problems, especially sleep apnea
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Work that involves changing shifts or night shifts
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_black"> </span>
                      Smoking
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      Although you can’t change risk factors such as family
                      history, age, or ethnicity, you can change lifestyle risk
                      factors around eating, physical activity, and weight.
                      These lifestyle changes can lower your chances of
                      developing insulin resistance or pre-diabetes
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p className="text-justify justify_content">
              Even if you discover that you do have pre-diabetes, remember that
              it doesn’t mean you’ll immediately develop diabetes. Diabetes can
              be prevented, especially if you follow a treatment plan and make
              changes in your lifestyle through food choices and physical
              activity. Even small changes can have a huge impact on delaying or
              preventing diabetes . Work with a health care professional to make
              a plan that works for your lifestyle.
            </p>
            <span className="fw-semibold font-xsm color-blue-abdominal mt-2">
              {" "}
              Prevention is always better than cure! So treat your Pre-diabetes
              to prevent Diabetes!
            </span>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space client-section ">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 ">
              <div className="custom-image-container fresh-image ">
                <img
                  src="../assets/images/ReducarbPrediabites/Prediabites-one.jpg"
                  alt="Abdominal Obesity"
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">
                        Is Pre-diabetes really a big deal?
                      </h1>
                    </div>
                    <div className="font-md">
                      <p className="justify_content">
                        Take pre-diabetes seriously!  Without adequate treatment/
                        changes, Pre-diabetes will progress into diabetes,
                        leading to complications. You can understand your risk
                        of getting diabetes by knowing your HbA1c levels.
                      </p>
                      <div className="font-xsm fw-semibold color-blue-abdominal">
                        Risk of getting diabetes within 5 years is 25% if your
                        HbA1c is between 5.7 to 6 % and 50% if it’s between 6 to
                        6.4 %
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* for Lapotop i want this  */}

      <section className="laptop-view">
        <div className="container-fluid-lg">
          <div className="d-flex justify-content-center align-items-center">
            <div className="text-center mb-3">
              <h1 className="font-lg mb-3">Pre-diabetes and gender</h1>
              <div className="text-center">
                <div className="font-sm mb-1 fw-semibold">
                  Does it affect differently?
                </div>
                <div className=" d-flex justify-content-center align-items-center">
                  <p className=" ">
                    Yes, the way men and women respond or are affected by
                    pre-diabetes/diabetes is different.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xl-4 pb-3">
              <div className="font-lmd fw-semibold text-center mb-3">
                    Men
              </div>
              <div className="d-flex flex-column gap-5">
                {/* <div className="d-flex gap-3 align-items-center margin-left-circle-top">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                    </i>
                  </div>
                  <div className="font-smd fw-semibold">
                    Pre-diabetes incidence: 41%
                  </div>
                </div> */}
                <div className="d-flex gap-3 align-items-center margin-left-circle">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-smd fw-semibold ">
                    More fasting blood glucose level
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-smd fw-semibold">
                    Less hormonal fluctuations
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center margin-left-circle ">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-smd fw-semibold">
                    Metabolize high levels of fructose
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center margin-left-circle-top ">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-smd fw-semibold">
                    Diagnosed with diabetes at a lower BMI
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 d-flex align-items-end justify-content-center ">
  <img
    src="../assets/images/ReducarbPrediabites/img_1.png"
    className="fit-image"
    alt="Pre-diabetes risks"
  />
</div>



            <div className="col-xl-4 pb-3 minus-left-margin">
            <div className="font-lmd fw-semibold text-center mb-3">
                    Women
              </div>
              <div className="d-flex flex-column gap-5">
                {/* <div className="d-flex gap-3 align-items-center margin-left-circle  ">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                    </i>
                  </div>
                  <div className="font-smd fw-semibold">
                    Pre-diabetes incidence: 32%
                  </div>
                </div> */}
                <div className="d-flex gap-3 align-items-center margin-left-circle-top">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-smd fw-semibold">
                    More high post-meal blood glucose level
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center justify-content-center  margin-left-circle-top-center ">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-smd fw-semibold">
                    More hormonal fluctuations
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center margin-left-circle-top ">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-sm fw-semibold">
                    Show distinct metabolic response to high fructose
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center  margin-left-circle ">
                  <div className="tick-green ">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-sm fw-semibold">
                    Diagnosed at higher BMIs, especially with central obesity
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-xl-4">
  <div className="d-flex flex-column gap-5">
    <div className="d-flex gap-3 align-items-center margin-left-circle">
      <div className="font-md fw-semibold">
 
      </div>
      <div className="tick-green">
        <i className="fa fa-check">

        </i>
      </div>
    </div>
    <div className="d-flex align-items-center margin-right-circle">
      <div className="font-md fw-semibold">
      
      </div>
      <div className="tick-green">
        <i className="fa fa-check">

        </i>
      </div>
    </div>
    <div className="d-flex align-items-center">
      <div className="font-md fw-semibold">
        
      </div>
      <div className="tick-green">
        <i className="fa fa-check">
     
        </i>
      </div>
    </div>
    <div className="d-flex align-items-center margin-right-circle">
      <div className="font-md fw-semibold">
       
      </div>
      <div className="tick-green">
        <i className="fa fa-check">

        </i>
      </div>
    </div>
    <div className="d-flex align-items-center margin-left-circle">
      <div className="font-md fw-semibold">

      </div>
      <div className="tick-green">
        <i className="fa fa-check">
      
        </i>
      </div>
    </div>
  </div>
</div> */}
          </div>

          <div></div>
        </div>
      </section>

      {/* for ipad and mobile i want this */}
      <section className="mobile-view">
        <div className="container-fluid-lg">
          <div className="d-flex justify-content-center align-items-center">
            <div className="text-center mb-3">
              <h1 className="font-lg mb-3">Pre-diabetes and gender</h1>
              <div className="text-center">
                <div className="font-sm mb-1 fw-semibold">
                  Does it affect differently?
                </div>
                <div className=" d-flex justify-content-center align-items-center">
                  <p className=" ">
                    Yes, the way men and women respond or are affected by
                    pre-diabetes/diabetes is different.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-xl-6 pb-3">
            <div className="font-lmd fw-semibold text-center mb-3">
                    Men
              </div>
              <div className="d-flex flex-column gap-5">
                {/* <div className="d-flex gap-3 align-items-center ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    Pre-diabetes incidence: 41%
                  </div>
                </div> */}
                <div className="d-flex gap-3 align-items-center ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    More fasting blood glucose level
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    Less hormonal fluctuations
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center  ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    Metabolize high levels of fructose
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center  ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    Diagnosed with diabetes at a lower BMI
                  </div>
                </div>
              </div>
            </div>
         

            <div className="col-xl-6 mt-4 mb-3 pb-3">
            <div className="font-lmd fw-semibold text-center mb-3">
                   Women
              </div>
              <div className="d-flex flex-column gap-5">
                {/* <div className="d-flex gap-3 align-items-center  ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    Pre-diabetes incidence: 32%
                  </div>
                </div> */}
                <div className="d-flex gap-3 align-items-center ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    More high post-meal blood glucose level
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center  ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    More hormonal fluctuations
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center  ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    Show distinct metabolic response to high fructose
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center  ">
                  <div className="tick-green">
                    <i className="fa fa-check">
                      {/* tick mark with green background */}
                    </i>
                  </div>
                  <div className="font-md fw-semibold">
                    Diagnosed at higher BMIs, especially with central obesity.
                  </div>
                </div>
              </div>
            </div>

    
          </div>

          <div></div>
        </div>
      </section>

      {/* <section className="fresh-vegetable-section section-lg-space background-blue-color">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-xl-6 text-white pe-5 mb-3  d-flex justify-content-centre with-border">
              <div>
                <div className="font-md fw-semibold mb-3">
                  Are the symptoms of Prediabetes in women different?
                </div>
                <div className="font-md mt-2 text-white">
                  <div className=" custom-list-item-height-two   fw-semibold font-xsm">
                    Prediabetes symptoms in women
                  </div>
                  <div className=" custom-list-item-height-two mb-2   font-xsm">
                    Apart from the usual signs of prediabetes mentioned earlier,
                    women may show certain different symptoms such as:
                  </div>

                  <div className="custom-list-effectonhealth mb-2 ps-3  ">
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_white"> </span>
                      Urinary tract infections
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_white"> </span>
                      Longer and heavier periods
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_white"> </span>
                      Reduced interest in sex
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_white"> </span>
                      Vaginal dryness that can make sex uncomfortable
                    </div>
                    <div className=" custom-list-item-height-two font-xsm">
                      <span className="me-2 bullet_point_white"> </span>
                      Trouble getting pregnant
                    </div>
                  </div>

                  <div className=" custom-list-item-height-two  fw-semibold color-blue-abdominal font-xsm">
                    Be proactive about diabetes – whether you’re male or female!
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 text-white padding-left-s d-flex justify-content-center ">
              <div>
                <div className="font-md fw-semibold mb-3">
                  Can carbohydrate restriction or low carbohydrates reverse
                  pre-diabetes?
                </div>
                <div className="font-xsm mb-4">
                  Carbohydrate restriction approach or low carbohydrates meal
                  plans can lead to lowering of hyper insulin state and reverse
                  insulin resistance, if present. This improves insulin
                  sensitivity and glucose uptake by various parts of the body.
                  This lowers blood glucose reversing the pre-diabetic state. It
                  also helps reducing body weight.
                </div>
                <div className="font-xsm color-blue-abdominal fw-semibold">
                  American Diabetic Association states, in light of the evidence
                  supporting the benefits of carbohydrate restriction, this
                  eating pattern should be considered as a legitimate option for
                  prediabetes.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

<section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">Are the symptoms of Pre-diabetes in women different? </h1>
                    </div>
                    <div>
                          <div className="font-sm mb-1 fw-semibold">
                          Pre-diabetes symptoms in women
            </div>
            <div className=" custom-list-item-height-two mb-2 text-muted font-xsm">
            Apart from the usual signs of pre-diabetes mentioned earlier, women may show certain different symptoms such as: 
              </div>
              <div className="custom-list-effectonhealth mb-2 ps-3 text-muted ">
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
               

                  Urinary tract infections

                </div>
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  Longer and heavier periods

                </div>
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  Reduced interest in sex

                </div>
                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  Vaginal dryness
             
                </div>

                <div className=" custom-list-item-height-two font-xsm">
                  <span className="me-2 bullet_point_black"> </span>
                  Trouble getting pregnant
             
                </div>

         
              </div>
              
            <div className="fw-semibold font-xsm color-blue-abdominal mt-2">
              {" "}
              Be proactive about diabetes – whether you’re male or female!
            </div>

        
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-5 d-flex align-items-center ">
              <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/ReducarbPrediabites/riskofheartdieases_5.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space ">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 ">
              <div className="custom-image-container fresh-image ">
                <img
                  src="../assets/images/ReducarbPrediabites/riskofheartdieases_9.jpg"
                  alt="Abdominal Obesity"
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">
                      Can carbohydrate restriction or low carbohydrates reverse pre-diabetes?
                      </h1>
                    </div>
                    <div className="font-md">
                      <p className="justify_content">
                      Carbohydrate restriction approach or low carbohydrates meal plans can lead to lowering of hyper insulin state and reverse insulin resistance, if present. This improves insulin sensitivity and glucose uptake by various parts of the body. This lowers blood glucose reversing the pre-diabetic state. It also helps reducing body weight
                      </p>
                      <div className="font-xsm fw-semibold color-blue-abdominal">
                      American Diabetic Association states, in light of the evidence supporting the benefits of carbohydrate restriction, this eating pattern should be considered as a legitimate option for pre-diabetes.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <section
          className="background-container background-blur-up background-loaded custom-image-container"
          style={{
            backgroundImage: "url('../assets/images/prediabete_calc.jpg')",
            backgroundSize: "cover", // Ensures the image covers the entire container
            backgroundRepeat: "no-repeat", // Prevents the image from repeating
            backgroundPosition: "center", // Centers the image within the container
          }}
        >
          <div></div>

          <div className="container-fluid-lg d-flex justify-content-around align-items-center py-3 my-4">
            <div className="w-75">
              <div>
                <div className="container content-container mb-5 text-white">
                  <h1 className="mb-2 font_Home_section text-white">
                  Pre-diabetes Risk calculator
                  </h1>


                  <button
                    onClick={() =>
                      (window.location.href = "/calculators")
                    }
                    className=" btn_get_started btns btn-animation-blue mt-xxl-4 mt-2 home-button mend-auto"
                  >
                    
                    Calculator 
                  </button>

                </div>
              </div>
            </div>
          </div>
        </section>  </section>

{/* <section className="fresh-vegetable-section section-lg-space">
  <div className="container-fluid-lg">
    <div>
      <div className="font-lg fw-semibold mb-3">References:</div>
      <div className="font-md mt-2 text-muted">
        <div className="custom-list-effectonhealth  references mb-2">
          <div className="custom-list-item-height-two font-xsm">
            <a  >
              https://doihaveprediabetes.org/
            </a>
          </div>
          <div className="custom-list-item-height-two font-xsm">
            <a   >
              https://www.cdc.gov/prediabetes/risktest/index.html
            </a>
          </div>
          <div className="custom-list-item-height-two font-xsm">
            <a   >
              https://www.mygnp.com/calculator/prediabetes-screening-test/
            </a>
          </div>
          <div className="custom-list-item-height-two font-xsm">
            <a   >
              https://www.cdc.gov/prediabetes/pdf/Prediabetes-Risk-Test-Final.pdf
            </a>
          </div>
          <div className="custom-list-item-height-two font-xsm">
            <a   >
              https://www.intolife.in/about-diabetes/diabetes-risk-score
            </a>
          </div>
          <div className="custom-list-item-height-two font-xsm">
            <a >
              https://www.diabetesaustralia.com.au/risk-calculator/
            </a>
          </div>
          <div className="custom-list-item-height-two font-xsm">
            <a  >
              https://www.fitterfly.com/prediabetes-risk-test
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> */}


<section className="fresh-vegetable-section section-lg-space">
  <div className="container-fluid-lg">
    <div className="review-title mb-3">
      <h1 className="font-lg mb-2">References:</h1>
    </div>
    <div className="references">
      <p><strong>1.</strong> <a  >https://doihaveprediabetes.org/</a></p>
      <p><strong>2.</strong> <a   >https://www.mygnp.com/calculator/prediabetes-screening-test/</a></p>
      <p><strong>3.</strong> <a   >https://www.cdc.gov/prediabetes/pdf/Prediabetes-Risk-Test-Final.pdf</a></p>
      <p><strong>4.</strong> <a   >https://www.cdc.gov/prediabetes/risktest/index.html</a></p>
      <p><strong>5.</strong> <a    >https://www.intolife.in/about-diabetes/diabetes-risk-score </a></p>
      <p><strong>6.</strong> <a    >https://www.diabetesaustralia.com.au/risk-calculator/ </a></p>
      <p><strong>7.</strong> <a   >https://www.fitterfly.com/prediabetes-risk-test      </a></p>
    </div>
  </div>
</section>



      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Prediabetes;
